/**
    * 根据参数名 获取 URL 路径中的参数
    * @param {String} name 要读取的参数名称
    */
function getUrlParam(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let search = window.location.href.split('?')[1]
  if (search) {
    var r = search.substr(0).match(reg)
    if (r !== null) return unescape(r[2])
    return null
  } else {
    return null
  }
}

export function getUrl(url, id) {
  let type = getUrlParam('type')
  let paramsId = getUrlParam('id')
  if (type == 1) {
    return url + paramsId + '&state='
  } else {
    return url + id + '&state=1'
  }
}

export function getJsonUrl(url) {
  let type = getUrlParam('type')
  if (type == 1) {
    return url + '&state='
  } else {
    return url + '&state=1'
  }
}
